import { InferOutput, literal, object } from 'valibot'
import { EntityTypeGroupId } from '../../EntityTypeGroupId.enum'
import { EntityTypeMeta, entityTypeDefaults } from '../../EntityTypeMeta'
import { HasXYSchema } from '../../has_xy'
import { BaseEntitySchema } from '../BaseEntity'
import { ELEVATION_LAND_FLOOR_DEFAULT } from '../EntityElevation/elevation_consts'
import { EntityElevationSchema } from '../EntityElevation/EntityElevation.type'
import { EntityIdSchema } from '../EntityId.type'
import { EntityLayerId } from '../EntityLayerId/EntityLayerId.enum'
import { EntityTypeId } from '../EntityTypeId.enum'

const entDefaults = {
  etype_id: EntityTypeId.Lake,
  layer_id: EntityLayerId.TerrainL1,
  floor_e: -1,
  water_e: ELEVATION_LAND_FLOOR_DEFAULT,
} as const

export const LakeEntitySchema = object({
  ...BaseEntitySchema.entries,
  etype_id: literal(EntityTypeId.Lake),
  layer_id: literal(EntityLayerId.TerrainL1),
  id: EntityIdSchema,
  floor_e: EntityElevationSchema,
  water_e: EntityElevationSchema,
  ...HasXYSchema.entries,
})

export type LakeEntity = InferOutput<typeof LakeEntitySchema>

/**
 * Inland body of fresh water, typically larger than a pond and surrounded by land.
 */
export const LakeEntityTypeMeta: EntityTypeMeta = {
  ...entityTypeDefaults,
  id: EntityTypeId.Lake,
  dname: 'Lake',
  layer_id: EntityLayerId.TerrainL1,
  group_id: EntityTypeGroupId.Terrain,
  defense: 0,
  entDefaults,
}

export function createLakeEntity(id: number, x: number, y: number): LakeEntity {
  return {
    ...entDefaults,
    heading: 0,
    id,
    x,
    y,
  }
}
